import { jsx as _jsx } from "react/jsx-runtime";
import { View } from 'react-native';
import { ProgressBarItem } from '../progress-bar-item';
import { getProgressBarCollectionStyles } from './ProgressBarCollectionStyles';
import { getTestId } from '@airtel/air-design-system';
export var ProgressBarCollection = props => {
  var _props$singleCardDeta = props.singleCardDetails,
    progressBarList = _props$singleCardDeta.progressBarList,
    progressBarPosition = _props$singleCardDeta.progressBarPosition,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InfoSummaryWidget' : _props$testID;
  var progressBarCollectionStyles = getProgressBarCollectionStyles(progressBarPosition);
  return (progressBarList === null || progressBarList === void 0 ? void 0 : progressBarList.length) > 0 && _jsx(View, Object.assign({
    style: progressBarCollectionStyles.progressBarCollectionWrapper
  }, getTestId(testID, 'progressBarList'), {
    children: progressBarList.map((value, index) => {
      var _a;
      var isLastItem = (_a = index == progressBarList.length - 1) !== null && _a !== void 0 ? _a : false;
      return _jsx(ProgressBarItem, Object.assign({}, value, {
        isLastItem: isLastItem
      }, getTestId(testID + '_progressBarList', index.toString()), {
        onUserAction: onUserAction
      }));
    })
  }));
};